import { ClockIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { routes } from 'config/routes'
import { CtaLink, Dialog } from 'shared/components'
import { PayoutForm } from '../PayoutForm/PayoutForm'
import type { PayoutItem } from '../../types/payouts.types'

type PayoutEditDialogProps = {
	payout: PayoutItem | null
	closeModal: () => void
}

export const PayoutEditDialog = ({ payout, closeModal }: PayoutEditDialogProps) => {
	const { t } = useTranslation()

	if (!payout) return null

	const title = t('Payout #{{ id }}', { id: payout.reference })

	return (
		<Dialog isOpened ariaLabel={title} className="max-h-[92vh] max-w-xl" closeModal={closeModal}>
			<div className="flex items-center gap-3 px-6 pb-4 pt-6">
				<div className="min-w-0 flex-1">
					<p className="text-[11px] font-medium text-muted-foreground">{t('Payouts / Edit')}</p>
					<h2 className="truncate font-display text-lg font-bold tracking-tight text-foreground">
						{title}
					</h2>
				</div>
				<CtaLink
					className="h-8 px-3 text-xs"
					to={routes.payoutHistory(String(payout.id))}
					text={t('History')}
					icon={<ClockIcon />}
					variant="outline"
				/>
				<button
					type="button"
					aria-label={t('Close')}
					className="grid h-9 w-9 shrink-0 place-items-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
					onClick={closeModal}>
					<XMarkIcon className="h-4 w-4 stroke-2" />
				</button>
			</div>
			<PayoutForm
				className="min-h-0 flex-1 overflow-y-auto px-6 pb-6"
				payout={payout}
				onSuccess={closeModal}
			/>
		</Dialog>
	)
}
